// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"X0-z","subtitle":"Y0-z","wrapper":"Z0-z","leftArrow":"_0-z","rightArrow":"a1-z"};